import { Controller } from '@hotwired/stimulus';
import SET_MAP from '../../../controllers/config/mapbox/setMap';
import SET_MARKERS from '../../../controllers/config/mapbox/setMarkers';

export default class extends Controller {
  static values = {
    propertyLat: String,
    propertyLng: String,
    style: String,
    publicKey: String,
    approximateLocation: Boolean,
    zoom: Number,
    lazy: Boolean
  };

  static targets = ['button', 'map', 'imageContainer'];

  connect() {
    if (this.hasLazyValue && this.lazyValue) return;

    this.initMap();
  }

  load() {
    if (this.hasButtonTarget) this.buttonTarget.hidden = true;
    if (this.hasImageContainerTarget) this.imageContainerTarget.style.display = 'none';
    if (this.hasMapTarget) this.mapTarget.classList.remove('hidden');
    requestAnimationFrame(() => this.initMap());
  }

  initMap() {
    this.handleCenter();
    this.initZoom();
    this.handleMap();
    this.handleMarker();
    this.handleZoom();
  }

  handleMap = () => {
    const container = this.hasMapTarget ? this.mapTarget : this.element;
    this.map = SET_MAP.initMap(this.publicKeyValue, this.center, this.zoom, this.styleValue, container)
    this.map.addControl(new mapboxgl.NavigationControl());
  };

  handleMarker = () => {
    if (this.approximateLocationValue === true) {
      this.marker = SET_MARKERS.main(this.map, [this.propertyLngValue, this.propertyLatValue], '','hosman-marker--approx-location')
    } else {
      SET_MARKERS.main(this.map, [this.propertyLngValue, this.propertyLatValue])
    }
  };

  handleCenter() {
    if (this.hasApproximateLocationValue && this.approximateLocationValue) {
      this.center = [Math.floor(this.propertyLngValue * 1000 + 2) / 1000, Math.floor(this.propertyLatValue * 1000 + 2) / 1000]
    } else {
      this.center = [this.propertyLngValue, this.propertyLatValue]
    }
  }

  initZoom() {
    if (this.hasZoomValue) this.zoom = this.zoomValue
    else if (this.hasApproximateLocationValue && this.approximateLocationValue) this.zoom = 12
    else this.zoom = 11
  }

  handleZoom() {
    if(this.marker === undefined) return

    this.map.on('zoom',  () => {
      const zoom = this.map.getZoom();
      const baseMarkerSize = 600;
      const scalingFactor = 0.5;

      const scaledMarkerSize = baseMarkerSize * Math.pow(scalingFactor, this.zoomValue - zoom);
      if (scaledMarkerSize < 30) return

      this.marker.getElement().style.width = scaledMarkerSize + 'px';
      this.marker.getElement().style.height = scaledMarkerSize + 'px';
    });
  }
}
